export default __webpack_public_path__ + "static/media/orange_top_arrow.7714985b.svg";